export enum OrientationType {
    Unknown = 'Unknown',
    Portrait = 'Portrait',
    Landscape = 'Landscape',
}

export enum DeviceType {
    Unknown = 'Unknown',
    Web = 'Web',
    Tablet = 'Tablet',
    Handset = 'Handset',
}

export enum ScreenSizeType {
    Unknown = 'unknown',
    XLarge = 'x-large',
    Large = 'large',
    Medium = 'medium',
    Small = 'small',
    XSmall = 'x-small',
}

export enum BreakpointType {
    Unknown = 'unknown',

    HandsetPortrait = 'handset-portrait',
    HandsetLandscape = 'handset-landscape',

    TabletPortrait = 'tablet-portrait',
    TabletLandscape = 'tablet-landscape',

    WebPortrait = 'web-portrait',
    WebLandscape = 'web-landscape',
}
